module.exports = __webpack_public_path__ + "img/logo-dne-market.d6dc210a.svg";